import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENV_CONFIG, EnvConfig } from './env-config.token';

@Injectable()
export abstract class ApiService {
  protected readonly httpClient: HttpClient = inject(HttpClient);
  protected readonly env: EnvConfig = inject(ENV_CONFIG);
}
